<div
  class="text-container mx-1.5 mb-2 flex flex-grow flex-col overflow-hidden rounded-3xl border-x-8 border-b-8 border-t-8 border-background-light-grey bg-background-light-grey text-text-secondary transition-[margin] duration-300"
  [ngClass]="errorState() ? 'outline outline-1 outline-states-red' : ''"
>
  <div class="flex items-center justify-between bg-background-light-grey pb-2 pr-4">
    <div class="flex flex-grow flex-wrap items-center gap-3">
      <lib-enhance-buttons
        [contextMenuHeaderConfig]="contextMenuHeaderConfig()"
        [isGenerating]="isGeneratingSignal()"
        [transcriptionStatus]="transcriptionStatus()"
        (buttonClick)="enhanceNote($event)"
      ></lib-enhance-buttons>
      <div class="flex h-8 items-center gap-2 max-[1176px]:flex-grow">
        <div class="flex items-center gap-1 max-[1176px]:mr-auto">
          <button
            type="button"
            class="flex h-8 w-8 items-center justify-center overflow-hidden rounded-xl text-primary-blue active:bg-background-disabled disabled:text-text-extra-light"
            [libUiTooltip]="undoTooltip"
            [tooltipPosition]="'bottom'"
            [disabled]="undoDisabledSignal() || transcriptionStatus() !== 'idle'"
            (click)="undo()"
          >
            <svg-icon key="px-24-undo" [style.width]="'20px'" [style.height]="'20px'"></svg-icon>
          </button>
          <ng-template #undoTooltip>
            <div class="px-3 py-2">
              <div class="typo-h7-light">{{ 'notes_undo_button' | translate }}</div>
            </div>
          </ng-template>
          <button
            type="button"
            class="flex h-8 w-8 items-center justify-center overflow-hidden rounded-xl text-primary-blue active:bg-background-disabled disabled:text-text-extra-light"
            [libUiTooltip]="redoTooltip"
            [tooltipPosition]="'bottom'"
            [disabled]="redoDisabledSignal() || transcriptionStatus() !== 'idle'"
            (click)="redo()"
          >
            <svg-icon key="px-24-redo" [style.width]="'20px'" [style.height]="'20px'"></svg-icon>
          </button>
          <ng-template #redoTooltip>
            <div class="px-3 py-2">
              <div class="typo-h7-light">{{ 'notes_redo_button' | translate }}</div>
            </div>
          </ng-template>
        </div>
      </div>
    </div>
    <button class="btn-text gap-[0.625rem] text-[0.875rem]" [disabled]="closeButtonDisabled()" (click)="onCloseClick()">
      {{ 'common_modal_close' | translate }}
    </button>
  </div>

  <div class="flex min-h-[112px] flex-grow flex-col justify-between overflow-y-auto rounded-3xl bg-background-white p-4">
    <lib-voice-typing-text-field
      #voiceTypingTextField
      [ngStyle]="textFieldMaxHeightStyle()"
      class="max-h-full overflow-auto"
      [value]="(controlledNote$ | async) ?? ''"
      [lastFocusedCursorOffset]="lastFocusedCursorOffsetSignal()"
      (lastFocusedCursorOffsetChange)="updateLastFocusedCursorOffset($event)"
      [transcriptionFormControl]="transcription"
      [transcriptionStatus$]="transcriptionStatus$"
      [isRecording]="transcriptionStatus() === 'recording'"
      [isRecordingLoading]="transcriptionStatus() === 'loading'"
      [placeholder]="'health_history_notes_section_placeholder_edit' | translate"
      (manualTypeKeyUp)="onManualTypeKeyUp($event)"
      (recordingLoading)="onRecordingLoading($event)"
      [lineBreakOnShiftEnter]="true"
      [isInputFocused]="isInputFocused()"
      [contextMenuHeaderConfig]="contextMenuHeaderConfig()"
      (generateText)="onGenerateTextFromContextMenu($event)"
    ></lib-voice-typing-text-field>

    <div
      class="mt-4 flex items-center gap-2"
      [ngClass]="{
        'justify-between': enableVoiceTyping(),
        'justify-end': !enableVoiceTyping()
      }"
    >
      @if (enableVoiceTyping()) {
        <div class="flex gap-2">
          <div class="relative">
            <button
              class="transition-[min-width, background-color] group flex h-full min-h-[32px] min-w-[32px] items-center justify-center rounded-xl bg-background-white p-1 text-states-purple duration-200 ease-in-out"
              (click)="onDictationClick()"
              [ngClass]="{
                'min-w-[169px] bg-states-purple shadow-[0px_4px_24px_0px] shadow-states-purple/30': transcriptionStatus() === 'recording'
              }"
              [disabled]="isGeneratingSignal()"
            >
              @switch (transcriptionStatus()) {
                @case ('idle') {
                  <svg-icon
                    [libUiTooltip]="startVoiceTypingTooltip"
                    [tooltipPosition]="'top'"
                    class=""
                    currentColor
                    key="px-24-voice-v-2"
                    size="md"
                  ></svg-icon>
                }
                @case ('loading') {
                  <ng-lottie class="h-4 w-4" currentcolor [options]="loadingLottieOptions"></ng-lottie>
                }
                @case ('recording') {
                  <svg-icon
                    [libUiTooltip]="stopVoiceTypingTooltip"
                    [tooltipPosition]="'top'"
                    key="px-40-stop"
                    class="text-text-white"
                    size="md"
                  ></svg-icon>
                }
              }
            </button>
          </div>

          @if (transcriptionStatus() === 'recording') {
            <div class="flex h-8 items-center gap-2">
              <ffd-audio-input-dropdown
                [activeDeviceId]="activeDeviceId()"
                (selectDevice)="onSelectDevice($event)"
              ></ffd-audio-input-dropdown>
            </div>
          }
        </div>
      }
      @if (autoSave()) {
        <div class="flex h-8 items-center justify-end gap-2">
          <lib-note-saving-indicator [isLoading]="isSaving()" [isSaved]="isSaved()" />
        </div>
      }
    </div>
  </div>
</div>

<ng-template #startVoiceTypingTooltip>
  <div class="text-h7">Voice Typing</div>
</ng-template>
<ng-template #stopVoiceTypingTooltip>
  <div class="text-h7">Stop Voice Typing</div>
</ng-template>
